import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCloudOff20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCloudOff20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M15.47 3.47a.75.75 0 1 1 1.06 1.06l-.529.529a5.48 5.48 0 0 1 1.576 4.52C18.45 10.308 19 11.38 19 12.575c0 2.195-1.86 3.975-4.154 3.975H5.154q-.306-.001-.601-.043L3.53 17.53a.75.75 0 1 1-1.06-1.06zM6.01 15.05h8.836c1.528 0 2.654-1.17 2.654-2.475 0-.719-.329-1.38-.885-1.845l-.624-.521.097-.808q.027-.23.027-.47a4 4 0 0 0-1.175-2.812zM11.73 3.3c.583 0 1.145.081 1.676.232l-1.284 1.284a4.52 4.52 0 0 0-3.285 1.012l-.517.428-.663-.1a3 3 0 0 0-.427-.031c-1.528 0-2.653 1.17-2.653 2.475q0 .16.02.313l.14 1.025-.912.494c-.817.442-1.325 1.254-1.325 2.143 0 .506.17.992.467 1.397l-1.07 1.069A3.85 3.85 0 0 1 1 12.575c0-1.485.85-2.78 2.111-3.462a4 4 0 0 1-.034-.513c0-2.196 1.86-3.975 4.153-3.975q.332 0 .65.048A6.02 6.02 0 0 1 11.73 3.3"
            />
        </svg>
    );
}
export default memo(IconCloudOff20);
